import { AsyncBoardWrapper } from '../../board/components/AsyncBoardWrapper';
import { AsyncIndexPageTable } from '../../../app/components/AsyncIndexPageTable';
import AsyncReportPage from '../../../app/components/AsyncReportPage';
import { AsyncIndexPageMap } from '../../../app/components/AsyncIndexPageMap';
import { AsyncIndexPageGantt } from '../../../app/components/AsyncIndexPageGantt';
import { View } from 'foundations-components/components/View';
import { AsyncBoardSettings } from './AsyncBoardSettings';
import { AsyncBoardSettingsProvider } from './AsyncBoardSettingsProvider';
import { memo } from 'react';
import { ReportPageSidebar } from '../../../app/components/ReportPageSidebar';
import { ReportToRenderProvider } from '../../../app/hooks/useReportToRender';

// Components memoized to avoid excessive re-renders
import { jsx as _jsx } from "react/jsx-runtime";
const TableComponent = /*#__PURE__*/memo(() => /*#__PURE__*/_jsx(AsyncIndexPageTable, {}));
TableComponent.displayName = 'TableComponent';
const ReportComponent = /*#__PURE__*/memo(() => /*#__PURE__*/_jsx(AsyncReportPage, {}));
ReportComponent.displayName = 'ReportComponent';
const MapComponent = /*#__PURE__*/memo(() => /*#__PURE__*/_jsx(View, {
  minBlockSize: "70vh",
  minInlineSize: "500px",
  children: /*#__PURE__*/_jsx(AsyncIndexPageMap, {})
}));
MapComponent.displayName = 'MapComponent';
export const REGISTRY = {
  // TODO: try memoizing the board components again
  BOARD: {
    VizComponent: AsyncBoardWrapper,
    // BoardSettings is now dynamically loaded via AsyncBoardSettings
    VizSettingsComponent: AsyncBoardSettings,
    // BoardSettingsProvider is now dynamically loaded via AsyncBoardSettingsProvider
    VizProvider: ({
      children,
      viewMeta
    }) => /*#__PURE__*/_jsx(AsyncBoardSettingsProvider, {
      objectTypeId: viewMeta.objectTypeId,
      children: children
    })
  },
  TABLE: {
    VizComponent: TableComponent
  },
  REPORT: {
    VizComponent: ReportComponent,
    VizSettingsComponent: ReportPageSidebar,
    VizProvider: ({
      children
    }) => /*#__PURE__*/_jsx(ReportToRenderProvider, {
      children: children
    })
  },
  MAP: {
    VizComponent: MapComponent
  },
  GANTT_CHART: {
    VizComponent: () => /*#__PURE__*/_jsx(AsyncIndexPageGantt, {})
  }
};